document.addEventListener("DOMContentLoaded", () => {
  const STORAGE_KEY = "save-product-state";
  const urlParams = new URL(window.location.toString())
  const shouldRestoreState = urlParams.searchParams.get("loadStore") === "true";
  const hasExplicitVariant = urlParams.searchParams.has("variant");
  const variantDefiningOptions = new Set(["Crystal Size", "크리스탈 사이즈"]);
  const currentState = shouldRestoreState
    ? JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}
    : {};

  Object.entries(currentState).forEach(([key, { nodeName, type, value }]) => {
    // Orientation links include the exact corresponding variant. Preserve
    // uploads, text, and add-ons without allowing stale size state to replace it.
    if (hasExplicitVariant && variantDefiningOptions.has(key)) return;

    let element;
    switch (nodeName) {
      case "BUTTON":
        console.log(
          "BUTTON",
          `.additional-row .product-list button[data-variant-id="${key}"][form]`,
          document.querySelector(
            `.additional-row .product-list button[data-variant-id="${key}"][form]`
          )
        );
        document
          .querySelector(
            `.additional-row .product-list button[data-variant-id="${key}"][form]`
          )
          ?.dispatchEvent(
            new MouseEvent("click", {
              view: window,
              bubbles: true,
              cancelable: true,
            })
          );
        document.activeElement.blur();
        break;
      case "INPUT":
        switch (type) {
          case "radio":
            document
              .querySelector(`[name="${key}"][value="${value}"][form]`)
              ?.click();
            document.activeElement.blur();
            break;
          case "text":
            element = document.querySelector(`[name="${key}"][form]`);
            if (element) {
              element.value = value;
              element.dispatchEvent(new Event("change"));
            }
            break;
        }
        break;
      case "SELECT":
        element = document.querySelector(`[name="${key}"][form]`);
        if (element) {
          element.value = value;
          element.dispatchEvent(new Event("change"));
        }
        break;
      case "TEXTAREA":
        element = document.querySelector(`textarea[name="${key}"][form]`);
        if (element) {
          element.value = value;
          element.dispatchEvent(new Event("change"));
        }
        break;
      case "FILESTACK_PHOTO":
        publish(PUB_SUB_EVENTS.filestackFileChoiced, {
          data: value,
        });
        break;
    }
  });

  const state = new Proxy(currentState, {
    set: (target, property, value, receiver) => {
      // if (["Crystal Size", "Light Base"].includes(property)) {
      //   return false;
      // }
      const result = Reflect.set(target, property, value, receiver);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(target));
      console.log(property, value);
      return result;
    },
    deleteProperty(target, property) {
      const result = Reflect.deleteProperty(target, property);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(target));
      console.log(target, property);
      return result;
    },
  });

  const onChange = (el) => {
    if (!el) return;
    const name = el.getAttribute("name");
    if (name) {
      state[name] = {
        nodeName: el.nodeName,
        type: el.getAttribute("type") || "text",
        value: el.value,
      };
    }
  };
  const onAdditionalClick = (el) => {
    const variantId = el.dataset.variantId;
    if (variantId) {
      if (state[variantId]) {
        delete state[variantId];
      } else {
        state[variantId] = {
          nodeName: el.nodeName,
          type: el.getAttribute("type") || "text",
          value: variantId,
        };
      }
    }
  };

  subscribe(
    PUB_SUB_EVENTS.filestackFileChoiced,
    ({ data }) => {
      state['FILESTACK_PHOTO'] = {
        'nodeName': 'FILESTACK_PHOTO',
        'type': 'FILE',
        value: data
      };
    }
  );

  document.addEventListener(
    "change",
    (event) => {
      if (!event || !event.target) return;
      if (!event.target.getAttribute("form")) return;
      onChange(event.target);
    },
    { passive: true }
  );

  document
    .querySelectorAll(".additional-row .product-list button[form]")
    .forEach((el) => {
      el.addEventListener("click", (event) => {
        onAdditionalClick(event.target);
      });
    });
});
